export default class RequiredError extends Error {
  constructor(message, fields) {
    super(message)
    this.name = 'RequiredError'
    this.fields = fields
  }
}
